// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"booking_wrapper__MVWxb","heading_wrapper":"booking_heading_wrapper__atsH9","title":"booking_title__8rFCR","button_wrapper":"booking_button_wrapper__BRO2P"};